import React, {useEffect, useState} from "react";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import {api} from "../services/apiService";

import {Box, CircularProgress, Container, ToggleButton, ToggleButtonGroup, Typography} from "@mui/material";

export default function ProductOrOptionForm(props) {
    const [categories, setCategories] = useState([]);
    const editionMode = props.editionMode || false;
    const showDurationField = props.showDurationField !== undefined ? props.showDurationField : true;
    const [loaded, setLoaded] = useState(false);
    const [formData, setFormData] = useState({
        category: "",
        name: "",
        description: "",
        price: "",
        duration: "",
        isActive: true,
        tva: 20
    });
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        const {name, value, type, checked} = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value,
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (loading) return; // Empêche les soumissions multiples
        setLoading(true);

        // Contrôle des champs requis
        if (!e.currentTarget.checkValidity()) {
            e.currentTarget.reportValidity();
            setLoading(false);
            return;
        }

        const priceHT = formData.price ? parseFloat(formData.price) / (1 + formData.tva / 100) : 0;

        props.onSubmit({...formData, price: priceHT}).finally(() => {
            setLoading(false);
        });
    };

    useEffect(() => {
        const request = api.get("/products/categories")
            .then(response => {
                setCategories(response.data);
            })
            .catch(error => {
                console.error("Error fetching categories:", error);
            });

        if (props.data) {
            setFormData({
                ...props.data,
                price: props.data.price ? (props.data.price * (1 + (props.data.tva !== undefined ? props.data.tva : 20) / 100)).toFixed(2) : ""
            });
        }

        request.finally(() =>
            setLoaded(true)
        );
    }, [props.data]);

    return (
        loaded ? (
                <form onSubmit={e => handleSubmit(e)} noValidate>
                    <Stack spacing={3} sx={{mt: 4}}>
                        <FormControl fullWidth>
                            <InputLabel id="category-label">Catégorie</InputLabel>
                            <Select
                                disabled={editionMode}
                                labelId="category-label"
                                name="category"
                                value={formData.category?.id || formData.category}
                                label="Catégorie"
                                onChange={handleChange}
                                required
                            >
                                {categories.map((cat) => (
                                    <MenuItem key={cat.id} value={cat.id}>{cat.name}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>

                        <TextField
                            name="name"
                            label="Nom"
                            value={formData.name}
                            onChange={handleChange}
                            required
                            fullWidth
                        />

                        <TextField
                            name="description"
                            label="Description"
                            value={formData.description}
                            onChange={handleChange}
                            multiline
                            rows={3}
                            fullWidth
                        />

                        <Stack direction="row" spacing={2}>
                            <TextField
                                name="price"
                                label="Prix TTC (€)"
                                type="number"
                                inputProps={{step: "0.01", min: "0"}}
                                value={formData.price}
                                onChange={handleChange}
                                required
                                fullWidth
                            />
                            <TextField
                                label="Prix HT (€)"
                                value={formData.price ? (parseFloat(formData.price) / (1 + formData.tva / 100)).toFixed(2) : ""}
                                InputProps={{
                                    readOnly: true,
                                }}
                                fullWidth
                            />
                        </Stack>

                        <ToggleButtonGroup
                            disabled={editionMode}
                            value={formData.tva}
                            name="tva"
                            exclusive
                            onChange={(e, value) => {
                                if (value !== null) setFormData(prev => {
                                    return {...prev, tva: value};
                                });
                            }}
                            size="medium"
                            color="primary"
                        >
                            <ToggleButton value={10} sx={{flexGrow: 1}}>10 %</ToggleButton>
                            <ToggleButton value={20} sx={{flexGrow: 1}}>20 %</ToggleButton>
                        </ToggleButtonGroup>

                        {/* 👇 Nouveau champ Durée */}
                        {showDurationField && <TextField
                            name="duration"
                            label="Durée (minutes)"
                            type="number"
                            inputProps={{min: "1"}}
                            value={formData.duration}
                            onChange={handleChange}
                            required
                            fullWidth
                        />}

                        <FormControlLabel
                            control={
                                <Checkbox
                                    name="isActive"
                                    checked={formData.isActive}
                                    onChange={handleChange}
                                />
                            }
                            label="Actif"
                        />

                        <Button type="submit" variant="contained" size="large" disabled={loading}>
                            {loading ? "Enregistrement..." : "Enregistrer"}
                        </Button>
                    </Stack>
                </form>
            )
            : (
                <Container maxWidth="lg"
                           sx={{mt: 4, display: "flex", justifyContent: "center", alignItems: "center", minHeight: "60vh"}}>
                    <Stack spacing={2} alignItems="center">
                        <Box>
                            <Typography variant="h6" sx={{mb: 2}}>Chargement des détails...</Typography>
                            <Box sx={{display: "flex", justifyContent: "center"}}>
                                <CircularProgress color="primary"/>
                            </Box>
                        </Box>
                    </Stack>
                </Container>
            )
    );
} 